function hasMethod(target, methodName) {
  return !!target && typeof target[methodName] === 'function';
}

export function createDataAdapter(adapterImplementation) {
  var adapter = adapterImplementation || {};

  if (!hasMethod(adapter, 'executeProcedure')) {
    throw new Error('Data adapter must implement executeProcedure(procedureName, params).');
  }

  if (!hasMethod(adapter, 'queryTable')) {
    throw new Error('Data adapter must implement queryTable(tableName, optionalWhere).');
  }

  if (!hasMethod(adapter, 'normalizeProcedureResult')) {
    throw new Error('Data adapter must implement normalizeProcedureResult(raw).');
  }

  return adapter;
}

export function normalizeRowsResult(raw) {
  if (Array.isArray(raw)) {
    return raw;
  }

  if (raw && Array.isArray(raw.rows)) {
    return raw.rows;
  }

  if (raw && Array.isArray(raw.data)) {
    return raw.data;
  }

  return [];
}
